import SkipLink from './skip-link';

export default SkipLink;
